import {
  DataTable,
  EditButton,
  RaRecord,
  Identifier,
} from 'react-admin';
import type { CatalogItem } from '@src/types';
import CatalogImageField from './CatalogImageField';

const CatalogDataTable = () => {
  return (
    <DataTable rowClick="edit" bulkActionButtons={false}>
      <DataTable.Col label="" render={(record: CatalogItem) => <CatalogImageField record={record} />} />
      <DataTable.Col source="title" />
      <DataTable.Col source="parentSku" label="Parent SKU" />
      <DataTable.Col source="variantCount" label="Variants" />
      <DataTable.Col source="category" />
      <DataTable.Col source="department" />
      <DataTable.Col source="brandDisplay" label="Brand" />
      <DataTable.Col label="" render={(record: CatalogItem & RaRecord<Identifier>) => <EditButton record={record} />} />
    </DataTable>
  );
};

export default CatalogDataTable;
